import JobSearchLanding from "../components/home/Landing";
import SEOHelmet from "../components/SEO/SEOHelmet";
import JobpilotWorkflow from "../components/home/HowItWorks";
import PopularCategories from "../components/home/PopularCategories";
import FeaturedJobs from "../components/home/FeaturedJobs";
import TopCompanies from "../components/home/TopCompanies";
import ClientsTestimonial from "../components/home/ClientsTestimonial";
import DualCTASection from "../components/home/DualCTASection";

export default function Home() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-red-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      <SEOHelmet 
        title="Accueil" 
        description="Trouvez votre emploi idéal ou recrutez les meilleurs talents algériens sur Tekhdem, la plateforme de recrutement de référence en Algérie."
      />
      <JobSearchLanding />
      <FeaturedJobs />
      <JobpilotWorkflow />
      {/* <PopularCategories /> */}

      <TopCompanies />
      <ClientsTestimonial />
      <DualCTASection />
    </div>
  );
}
